/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

class Setting extends Component {
  state = {};

  componentDidMount = () => {
    this._getSetting();
  };

  _getSetting = async () => {
    const { loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      const result = await this._getSettingApi();
      const intReturn = result.data[0].intReturn;
      const settingList = result.data[0].listData;

      if (intReturn === 0) {
        this.setState({
          settingList,
        });
      }
    }
  };

  _getSettingApi = () => {
    const { apiUrl, loginId } = this.props;

    return axios
      .post(apiUrl + '/setting', {
        params: {
          userid: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };
  _onChangeBitrate = (bitrate) => {
    const { onChangeBitrate } = this.props.childProps;
    onChangeBitrate(bitrate);
  };
  _onChangeAutoNext = (autoNext) => {
    const { onChangeAutoNext } = this.props.childProps;
    onChangeAutoNext(autoNext);
  };
  _onChangeAutoSkip = (autoSkip) => {
    const { onChangeAutoSkip } = this.props.childProps;
    onChangeAutoSkip(autoSkip);
  };
  _onChangeAutoSkipEnd = (autoSkipEnd) => {
    const { onChangeAutoSkipEnd } = this.props.childProps;
    onChangeAutoSkipEnd(autoSkipEnd);
  };

  render() {
    const { settingList } = this.state;
    //console.log(settingList)
    return (
      <Fragment>
        {settingList ? (
          <div className="set_pop">
            <dl>
              <dt>화질설정</dt>
              {/*<dd><a style={{ cursor: 'pointer'}} className="on">자동</a></dd>*/}
              <dd>
                <a
                  style={{ cursor: 'pointer' }}
                  className={settingList[0].bitrate === '1080P' ? 'on' : null}
                  onClick={() => this._onChangeBitrate('1080P')}
                >
                  1080P
                </a>
              </dd>
              <dd>
                <a
                  style={{ cursor: 'pointer' }}
                  className={settingList[0].bitrate === '720P' ? 'on' : null}
                  onClick={() => this._onChangeBitrate('720P')}
                >
                  720P
                </a>
              </dd>
            </dl>
            <dl>
              <dt>재생설정</dt>
              <dd>
                <a
                  style={{ cursor: 'pointer' }}
                  className={settingList[0].autoNext === 'Y' ? 'on' : null}
                  onClick={() =>
                    this._onChangeAutoNext(
                      settingList[0].autoNext === 'Y' ? 'N' : 'Y'
                    )
                  }
                >
                  연속재생
                </a>
              </dd>
              {/*
                            <dd><a style={{ cursor: 'pointer'}} className={settingList[0].autoSkip === 'Y' ? 'on' : null } onClick={()=>this._onChangeAutoSkip(settingList[0].autoSkip==='Y'? 'N' : 'Y')}>오프닝 스킵</a></dd>
                            <dd><a style={{ cursor: 'pointer'}} className={settingList[0].autoSkipEnd === 'Y' ? 'on' : null } onClick={()=>this._onChangeAutoSkipEnd(settingList[0].autoSkipEnd==='Y'? 'N' : 'Y')}>엔딩 스킵</a></dd>
                            */}
            </dl>
          </div>
        ) : null}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Setting));
